$(function () {
	$.nette.ext('modal', {
		init: function () {
			this.modals = [];
		},
		success: function (payload) {
			if (payload.closeModal) {
				var lastModal = this.modals.pop();
				if (lastModal) {
					lastModal.modal('hide');
				}
				return;
			}
			if (!payload.modal || !payload.snippets) {
				return;
			}
			var name = "snippet--" + payload.modal; //todo: component support
			if (!payload.snippets[name]) {
				return;
			}
			var modal = $('<div class="modal"><div class="modal-dialog modal-lg"><div class="modal-content">' +
				'<div class="modal-body">' +
				payload.snippets[name] +
				'</div></div></div></div>');
			modal.modal();
			var self = this;
			var hideModal = function (e) {
				if (e.currentTarget !== modal) {
					return;
				}
				var index = self.modals.indexOf(modal);
				if (index !== -1) {
					self.modals.splice(index, 1);
				}
				modal.remove();
				var last = self.modals[self.modals.length - 1];
				if (last) {
					//last.off('hidden.bs.modal');
					//last.modal('hide');
					//last.modal('show');
					//last.on('hidden.bs.modal', hideModal);
				}
			};
			modal.on('hidden.bs.modal', hideModal);
			this.modals.push(modal);
			$.nette.load();
		}
	});
	$.nette.ext('wysiwyg', {
		success: function () {
			this.initializeWysiwyg();
		},

		init: function () {
			this.initializeWysiwyg = function () {
				$(".summernote").summernote({
					iconPrefix: 'icon-',
					icons: {
						'align': 'icon-align-left',
						'alignCenter': 'icon-align-center',
						'alignJustify': 'icon-align-justify',
						'alignLeft': 'icon-align-left',
						'alignRight': 'icon-align-right',
						'indent': 'icon-indent',
						'outdent': 'icon-outdent',
						'arrowsAlt': 'icon-arrows-alt',
						'bold': 'icon-bold',
						'caret': 'caret',
						'circle': 'icon-circle',
						'close': 'icon-close',
						'code': 'icon-code',
						'eraser': 'icon-eraser',
						'font': 'icon-font',
						'frame': 'icon-frame',
						'italic': 'icon-italic',
						'link': 'icon-link',
						'unlink': 'icon-chain-broken',
						'magic': 'icon-magic',
						'menuCheck': 'icon-check',
						'minus': 'icon-minus',
						'orderedlist': 'icon-list-ol',
						'pencil': 'icon-pencil',
						'picture': 'icon-picture-o',
						'question': 'icon-question',
						'redo': 'icon-repeat',
						'square': 'icon-square',
						'strikethrough': 'icon-strikethrough',
						'subscript': 'icon-subscript',
						'superscript': 'icon-superscript',
						'table': 'icon-table',
						'textHeight': 'icon-text-height',
						'trash': 'icon-trash',
						'underline': 'icon-underline',
						'undo': 'icon-undo',
						'unorderedlist': 'icon-list-ul',
						'video': 'icon-youtube-play'
					},
					lang: 'cs-CZ',
					toolbar: [
						['style', ['style']],
						['font', ['bold', 'italic', 'underline', 'clear']],
						// ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
						['fontsize', ['fontsize']],
						['color', ['color']],
						['para', ['ul', 'ol', 'paragraph']],
						['height', ['height']],
						['insert', ['link', 'picture', 'hr']],
						['view', ['fullscreen', 'codeview']]
					],
					height: '400px'
				});
			};
			this.initializeWysiwyg();
		}

	});
	$.nette.init();
	var supportsColorInput = (function () {
		var inputElem = document.createElement('input'), bool, docElement = document.documentElement, smile = ':)';

		inputElem.setAttribute('type', 'color');
		bool = inputElem.type !== 'text';

		// We first check to see if the type we give it sticks..
		// If the type does, we feed it a textual value, which shouldn't be valid.
		// If the value doesn't stick, we know there's input sanitization which infers a custom UI
		if (bool) {

			inputElem.value = smile;
			inputElem.style.cssText = 'position:absolute;visibility:hidden;';

			// chuck into DOM and force reflow for Opera bug in 11.00
			// github.com/Modernizr/Modernizr/issues#issue/159
			docElement.appendChild(inputElem);
			docElement.offsetWidth;
			bool = inputElem.value != smile;
			docElement.removeChild(inputElem);
		}

		return bool;
	})();
	if (supportsColorInput) {
		$("input.colorpicker").attr("type", "color").removeClass("colorpicker").css("padding", "4px");
	} else {
		$('.colorpicker').colorpicker();
	}


	$("[data-nette-datetime]").each(function () {
		var format = $(this).data('nette-datetime');
		$(this).datetimepicker({format: format, minView: 'month', language: 'cs', autoclose: true});
		$(this).attr("type", "text");
	});
});
